
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header");
  const hash = window.location.hash;

  if (hash && header) {
    const target = document.querySelector(hash);
    setTimeout(function() {
    smoothScrollToTarget(target, header.offsetHeight);
    },4000);
  }
});

function smoothScrollToTarget(target, offset) {
  if (target) {
    const offsetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      top: 6500,
      behavior: 'smooth'
    });
    console.log("target:", target);
    console.log("offsetTop:", offsetTop);
    console.log("headerHeight:", offset);

  }
}




// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
      intro.onclick = (e) => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(e.target.closest('[js-acc-item]'));
        }
      };
    }
  });   
}


function CartSlider() {
  const accordions = document.querySelector("[data-reint-cart-slider]") || null;
  if(!accordions) return;
  const swiper_int = accordions.querySelector("[data-applay-slider]") || null;
  const  product_modal_sliderOptions = accordions.getAttribute('data-reint-cart-slider') || null;
  const product_modal_slideroptionConfig =JSON.parse(product_modal_sliderOptions) || null;
  if(product_modal_slideroptionConfig && swiper_int){
    const cart_slider = new Swiper(swiper_int, product_modal_slideroptionConfig);
  }
}


(function() {
  faq_taggol();
  CartSlider();
})();


//faq section
const faq_main_wap = document.querySelector('[faq_main_wap]') || null;
if (faq_main_wap) {
  const faq_toggles = faq_main_wap.querySelectorAll('[data-act-title]') || null;
  const faq_content_wap = faq_main_wap.querySelector('[faq_content_wap]') || null;
  const faq_content_tabs = faq_content_wap.querySelectorAll('.tabs') || null;
  const faq_dropdown = faq_main_wap.querySelector('.faq-category-dropdown') || null;
  const faq_selected = faq_main_wap.querySelector('.faq-category-selected') || null;
  const mian_tag = document.querySelector('.faq-category')|| null;
  const content = document.querySelector("[js-acc-single-content]");
  
  if (faq_content_wap) {
    faq_toggles.forEach((faq) => {
      faq.addEventListener('click', (event) => {
        faq_content_tabs.forEach((tab) => {
          tab.classList.remove('active');
          tab.style.display = 'none';
        });

        faq_toggles.forEach((toggle) => {
          toggle.classList.remove('active-tab');
        });

        const targetSelector = event.currentTarget.getAttribute('data-act-title');
        const targetTab = faq_content_wap.querySelector(targetSelector);

        if (targetTab) {
          targetTab.classList.add('active');
          targetTab.style.display = 'block';
          
         
        }
        event.currentTarget.classList.add('active-tab');
        

        if (faq_dropdown && faq_selected) {
          faq_selected.textContent = event.currentTarget.textContent.trim();
          faq_dropdown.classList.remove('open'); // Adjust class based on your dropdown open state
          mian_tag.classList.remove('active');
          if(content){
            content.style.maxHeight = null;
          }
        }
      });
    });

    if (faq_dropdown) {
      faq_dropdown.addEventListener('click', () => {
        faq_dropdown.classList.toggle('open'); // Add/remove "open" class for the dropdown
      });
    }
  }
}
//faq section end

// bundle pdp
function custom_addtocart_fun(product) {
  // console.log("function called");

  fetch(`${Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: { 
      "Accept": "application/json", 
      "Content-Type": "application/json" 
    },
    body: JSON.stringify(product)
  })
  .then(response => response.json())
  .then(data => {
    // console.log("data", data);

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: data,
      })
    );
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}


// hotsport start
function hosport_click(item) {
  item.addEventListener("click", (event) => {
    event.stopPropagation(); // Prevent body click event from firing immediately
    
    let hide_content = document.querySelectorAll("[data-host-port-content]");
    let targetSelector = event.target.getAttribute('data-hotsport-click');
    let targetContent = document.querySelector(targetSelector);

    if (targetContent) {
      if (targetContent.classList.contains('hidden')) {
        // Hide all other content
        hide_content.forEach(b => b.classList.add("hidden"));
        
        // Show the clicked content
        targetContent.classList.remove("hidden");
        targetContent.classList.add("show_spot");
        document.body.classList.add('overflow_hidden');
      } else {
        // Hide current content
        targetContent.classList.add("hidden");
        targetContent.classList.remove("show_spot");
        document.body.classList.remove('overflow_hidden');
      }
    }
  });
}

// Attach event to all elements with [data-hotsport-click]
document.querySelectorAll("[data-hotsport-click]").forEach(hosport_click);

// Body click to close content when clicking outside
document.body.addEventListener("click", (event) => {
  if (document.body.classList.contains("overflow_hidden")) {
    // Ignore clicks inside the currently open content
    if (!event.target.closest('.show_spot[data-host-port-content]')) {
      console.log("Closing content");

      document.querySelector('.show_spot[data-host-port-content]')?.classList.add("hidden");
      document.querySelector('.show_spot[data-host-port-content]')?.classList.remove("show_spot");
      document.body.classList.remove('overflow_hidden');
    }
  }
});
// hotsport end

// pdp tab swiper
let desktopSwiper = null;

function initDesktopSwiper() {
  if (window.innerWidth >= 700 && desktopSwiper === null) {
    desktopSwiper = new Swiper('[fonts-container] .tab_title_cls', {
      // your Swiper options here
      slidesPerView: "auto",
      spaceBetween: 20,
      navigation:{
        nextEl:".swiper-button-next.tab_title",
        prevEl:".swiper-button-prev.tab_title"
      }
      // breakpoints: {
      //   0: { slidesPerView: 2},
      //   700: { slidesPerView: 2},
      //   1000: { slidesPerView: 3},
      //   1200: { slidesPerView: 4.2 }
      // }
      // etc.
    });
  } else if (window.innerWidth < 768 && desktopSwiper !== null) {
    desktopSwiper.destroy(true, true);
    desktopSwiper = null;
  }
}

// Run on load
initDesktopSwiper();

// Re-check on resize
// window.addEventListener('resize', initDesktopSwiper);


// // lightbox code

// const lightbox = document.getElementById("customLightbox");
// const swiperWrapper = document.getElementById("swiperSlides");
// const closeBtn = document.getElementById("closeLightbox");

// let swiper;

// document.querySelectorAll(".icon-with-text").forEach(icon => {
//   if (icon) {  
//     icon.addEventListener("click", function () {
//       const parentWrapper = icon.closest(".icon-wrapper");
//       const localIcons = parentWrapper.querySelectorAll(".icon-with-text");
  
//       // Get slides for this tab only
//       const slidesData = Array.from(localIcons).map(el => ({
//         image: el.dataset.images,
//         title: el.dataset.title
//       }));
  
//       // Determine index of clicked image within current tab
//       const clickedIndex = Array.from(localIcons).indexOf(icon);
  
//       // Clear existing slides
//       swiperWrapper.innerHTML = "";
  
//       // Build Swiper slides for this tab
//       slidesData.forEach(slide => {
//         const slideDiv = document.createElement("div");
//         slideDiv.classList.add("swiper-slide", "text-center", "p-4");
//         slideDiv.innerHTML = `
//           <img src="${slide.image}" alt="${slide.title}" class="mx-auto mb-2 max-h-96">
//           <div class="text-lg font-semibold">${slide.title}</div>
//         `;
//         swiperWrapper.appendChild(slideDiv);
//       });
  
//       // Show the lightbox
//       lightbox.classList.remove("hidden");
  
//       // Re-init Swiper for current tab only
//       if (swiper) swiper.destroy(true, true);
//       swiper = new Swiper(".lightbox-swiper", {
//         initialSlide: clickedIndex,
//         navigation: {
//           nextEl: ".swiper-button-next",
//           prevEl: ".swiper-button-prev"
//         }
//       });
//     });
//   }
// });

// Close button
// if (closeBtn) {
//  closeBtn.addEventListener("click", () => {
//    lightbox.classList.add("hidden");
//  }); 
// }

// // Click outside to close
// if (lightbox) {
//  lightbox.addEventListener("click", function (event) {
//     if (event.target === lightbox) {
//       lightbox.classList.add("hidden");
//     }
//   }); 
// }


// page content show more and less then

document.querySelectorAll('.content-wrapper').forEach(wrapper => {
  const content = wrapper.querySelector('.richtext-content');
  const readMoreBtn = wrapper.querySelector('.read-more-btn');
  const readLessBtn = wrapper.querySelector('.read-less-btn');

  if (!content || !readMoreBtn || !readLessBtn) return;

  const fullText = content.dataset.fullContent; // full content from Liquid
  const shortText = content.innerHTML;          // initial 30 words

  readMoreBtn.addEventListener('click', (e) => {
    e.preventDefault();
    content.innerHTML = fullText;               // show full content
    readMoreBtn.classList.add('hidden');    
    readLessBtn.classList.remove('hidden'); 
    wrapper.classList.add('active');            // add active class
  });

  readLessBtn.addEventListener('click', (e) => {
    e.preventDefault();
    content.innerHTML = shortText;              // collapse back to 30 words
    readLessBtn.classList.add('hidden');    
    readMoreBtn.classList.remove('hidden'); 
    wrapper.classList.remove('active');         // remove active class
  });
});



  document.querySelectorAll(".gift-variant-select").forEach(function(select) {
    select.addEventListener("change", function() {
      console.log("select",select);
      const variantId = this.value; 
      const checkboxSelector = this.getAttribute("data-checkbox");
      const checkbox = document.querySelector(checkboxSelector);
      console.log("variantId",variantId,"checkboxSelector",checkboxSelector,"checkbox",checkbox);
      if (checkbox) {
        checkbox.setAttribute("product_id", variantId);
      }
    });
  });


// document.addEventListener("DOMContentLoaded", function () {
//   const container = document.querySelector('[data-pagination-link]');
//   if (!container) return;

//   let isLoading = false;

//   function observeButton() {
//     const loadMoreBtn = container.querySelector('[data-pagination-btn]');
//     if (!loadMoreBtn || isLoading) return;

//     // Button visible na hoy to pan observer work kare
//     loadMoreBtn.style.display = 'block';
//     loadMoreBtn.style.visibility = 'hidden';

//     const observer = new IntersectionObserver(
//       (entries, obs) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting && !isLoading) {
//             isLoading = true;

//             // Trigger pagination
//             loadMoreBtn.click();

//             // Stop observing current button
//             obs.unobserve(loadMoreBtn);

//             // Wait for new products & next button
//             setTimeout(() => {
//               isLoading = false;
//               observeButton();
//             }, 500);
//           }
//         });
//       },
//       {
//         root: null,
//         rootMargin: "200px",
//         threshold: 0,
//       }
//     );

//     observer.observe(loadMoreBtn);
//   }

//   // Start infinite scroll
//   observeButton();
// });
